'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "List": "Polaris-List",
  "typeNumber": "Polaris-List--typeNumber",
  "Item": "Polaris-List__Item",
  "spacingLoose": "Polaris-List--spacingLoose"
};

exports.default = styles;
